import { format } from 'date-fns';

export const formatDate = (
  value: string | number | Date | null | undefined,
): string => (value ? format(value, 'LLL d, y') : '');
